import React, { useState, useEffect } from "react";

function Timer({ setPhase }) {
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [game, setGame] = useState("");

  useEffect(() => {
    let min = localStorage.getItem("min");
    let sec = localStorage.getItem("sec");

    if (min !== null) setMin(min);
    if (sec !== null) setSec(sec);
  }, []);

  const handleClick = phase => {
    setPhase("game");
    setGame("game");
    localStorage.setItem("phase", "game");
    localStorage.setItem("min", min);
    localStorage.setItem("sec", sec);
  };

  const handleBack = () => {
    setPhase("");
    setGame("");
    localStorage.setItem("phase", "main");
  };

  return (
    <div className="container timer-stage">
      <button className="btn-back" onClick={() => handleBack()}>
        <i className="fas fa-arrow-left" />
      </button>
      <div className="easy">
        <div className="timer-div">
          <h3>
            Elige el tiempo para formar palabras, por defecto es ilimitado!
          </h3>
        </div>
        <div className="timer-container">
          <div className="time-grid">
            <div className="time-min-label">
              <p>Min</p>
            </div>
            <div className="time-sec-label">
              <p>Sec</p>
            </div>
            <div className="time-min-up">
              <button
                onClick={() => {
                  setMin(parseInt(min) + 1);
                }}
                className="btn-arrow"
              >
                <i className="fas fa-angle-up" />
              </button>
            </div>
            <div className="time-sec-up">
              <button
                onClick={() => {
                  if (sec < 60) {
                    setSec(parseInt(sec) + 1);
                  }
                }}
                className="btn-arrow"
              >
                <i className="fas fa-angle-up" />
              </button>
            </div>
            <div className="time-min time-btn">
              <p>
                {min}
              </p>
            </div>
            <div className="time-sec time-btn">
              <p>
                {sec}
              </p>
            </div>
            <div className="time-min-down">
              <button
                onClick={() => {
                  if (min > 0) {
                    setMin(min - 1);
                  }
                }}
                className="btn-arrow"
              >
                <i className="fas fa-angle-down" />
              </button>
            </div>
            <div className="time-sec-down">
              <button
                onClick={() => {
                  if (sec > 0) {
                    setSec(sec - 1);
                  }
                }}
                className="btn-arrow"
              >
                <i className="fas fa-angle-down" />
              </button>
            </div>
          </div>
        </div>
        <button onClick={() => handleClick()} className="btn play">
          <p>Jugar</p>
        </button>
      </div>
    </div>
  );
}

export default Timer;
